<lin-layout-section [title]="'CLIENT.USERS.EDIT_USER' | translate">
  <lin-tab-nav-bar [navLinks]="navLinks"></lin-tab-nav-bar>
</lin-layout-section>
